module.exports = __webpack_public_path__ + "static/img/news2.051602e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/news2.jpg
// module id = Amoh
// module chunks = 1